"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _getValidObject = _interopRequireDefault(require("../get-valid-object"));

/**
 * A class for mapping data from an arbitrary object to a known shape
 * @alias module:dataMap
 */
var DataMap =
/**
 * Create a new data map
 * @param {object} options - See below
 * @param {string} options.valuePropertyName - The property name for the value of the data point
 * @param {string} options.keyPropertyName - The property name for the key of the data point
 */
function DataMap(options) {
  (0, _classCallCheck2.default)(this, DataMap);
  var safeOptions = (0, _getValidObject.default)(options);

  if (!safeOptions.valuePropertyName) {
    safeOptions.valuePropertyName = 'value';
  }

  if (typeof safeOptions.valuePropertyName !== 'string') {
    throw new TypeError("options.valuePropertyName, if provided, must be a string. Provided value: ".concat(safeOptions.valuePropertyName));
  }

  if (!safeOptions.keyPropertyName) {
    safeOptions.keyPropertyName = 'key';
  }

  if (typeof safeOptions.keyPropertyName !== 'string') {
    throw new TypeError("options.keyPropertyName, if provided, must be a string. Provided value: ".concat(safeOptions.keyPropertyName));
  }

  this.valuePropertyName = safeOptions.valuePropertyName;
  this.keyPropertyName = safeOptions.keyPropertyName;
  Object.freeze(this);
};
/**
 * @module dataMap
 */


var _default = DataMap;
exports.default = _default;